import React from "react";
import PropTypes from "prop-types";

import { IconContainer, Text } from "shipnow-mercurio";

import { Styles } from "./LoadingPageLayout.styles";

const DEFAULT_PROPS = {
  fullScreen: false,
};

export const LoadingPageLayout = (props) => {
  //? merge default attrs with attrs.
  const attrs = {
    ...DEFAULT_PROPS,
    ...props,
  };

  return (
    <Styles.Wrapper fullScreen={attrs.fullScreen}>
      <IconContainer icon="spinner" size="spot" spin />

      <Text color="blackMediumEmphasis" margin="t-16">
        Cargando...
      </Text>
    </Styles.Wrapper>
  );
};

LoadingPageLayout.propTypes = {
  fullScreen: PropTypes.bool,
};
